import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Core2Config} from '../../shared/core2Config';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { MembershipClassHdrContainerModel } from '../../../../../../models/aggregates/crm/membership-class';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';

@Injectable({
  providedIn: 'root'
})
export class MembershipClassHdrService extends BaseApiPublicLoginTemplateService<MembershipClassHdrContainerModel, MembershipClassHdrContainerModel, MembershipClassHdrContainerModel> {

  static readonly MEMBER_CLASS_SUB_PATH = 'membership-class';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + MembershipClassHdrService.MEMBER_CLASS_SUB_PATH;

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + MembershipClassHdrService.MEMBER_CLASS_SUB_PATH;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + MembershipClassHdrService.MEMBER_CLASS_SUB_PATH;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + MembershipClassHdrService.MEMBER_CLASS_SUB_PATH + "/" + BaseApiTemplateService.PUBLIC_EP;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + MembershipClassHdrService.MEMBER_CLASS_SUB_PATH + "/"+ BaseApiTemplateService.LOGIN_EP;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + MembershipClassHdrService.MEMBER_CLASS_SUB_PATH + "/"+ BaseApiTemplateService.LOGIN_ENTITY_EP;
  }
}
